// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__209M7","icon":"styles_icon__1j9Su"};